<template>
  <div class="container">
    <div class="btn-wrapper">
    <el-select
      size="mini"
      class="filter-item"
      style="width: 150px"
      value-key="canteen_name"
      v-model="listQuery.canteen"
      placeholder="餐厅选择"
      @change="handleFilter"
    >
      <el-option
        v-for="canteen in canteenList"
        :key="canteen.canteen_id"
        :label="canteen.canteen_name"
        :value="canteen">
      </el-option>
      </el-select>
      &nbsp;
      <el-button type="primary" @click="toggleFaceShow" size="mini">添加人脸用户</el-button>
      <el-button type="primary" @click="getAllUsers" size="mini">查询</el-button>
      &nbsp;
      <el-badge class="mark" :value="users.length">
        <el-tag type="success" size="mini">总计</el-tag>
      </el-badge>

    </div>
    <el-table
      :data="users"
      style="width: 60%">
      <el-table-column
        type="index"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        label="consume_token"
        align="center"
        prop="consume_token">
      </el-table-column>
      <el-table-column
        label="人脸信息"
        align="center"
        prop="meta_data"
      >
        <template slot-scope="scope">
          <el-popover
            ref="popover1"
            placement="top-start"
            width="200"
            trigger="click">
            <img :src="scope.row.url" alt="" class="face-image face-image-big" >
            <img :src="scope.row.url" class="face-image" alt="" slot="reference" >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="meta_data"
        label="其他信息">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editUser(scope.row)" size="mini">编辑</el-button>
          <el-button class="danger-text" type="text" @click="deleteUser(scope.row.user_id)" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="提示"
      :visible.sync="faceUserFormShow"
      width="500px">
      <el-form ref="form" :model="userForm" :rules="rules" label-width="80px">
        <el-form-item label="token" prop="consume_token">
          <el-input v-model="userForm.consume_token" placeholder="请输入手机号或其他token"></el-input>
        </el-form-item>
        <el-form-item label='照片' prop="face">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <div class="image-wrapper" v-if="userForm.face">
              <img  :src="userForm.face" class="avatar image-item">
            </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="其他信息" prop="meta_data">
          <el-input v-model="userForm.meta_data" placeholder="请输入其他信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd">取 消</el-button>
        <el-button type="primary" @click='addUser'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>`
<script>
import { mapActions, mapMutations } from 'vuex'
import { apiGetFaceUsers, apiaddFaceUsers, apiEditFaceUser, apiDeleteFaceUser } from '@/api'
import { getImage } from '@/util/aliOssUpload'
import util from '@/util/util'

import uuidv1 from 'uuid/v1'

export default {
  name: 'faceAdmin',
  components: {},
  data () {
    return {
      editFlag: false,
      users: [],
      faceUserFormShow: false,
      userForm: {
        meta_data: '',
        face: '',
        consume_token: '',
        user_id: ''
      },
      listQuery: {
        canteen: {}
      },
      rules: {
        consume_token: [
          { required: true, message: '请输入token', trigger: 'blur' },
          { max: 128, message: '长度在最大128个字符', trigger: 'blur' }
        ],
        face: [
          { required: true, message: '请输入人脸图片' }
        ],
        meta_data: [
          { max: 128, message: '长度在最大128个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.listQuery.canteen = this.canteenList[0]
    this.getAllUsers()
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
    cancelAdd () {
      this.editFlag = false
      this.faceUserFormShow = false
      // console.log(?)
      this.$refs.form.resetFields()
      this.$refs.form.clearValidate()
      this.userForm = {
        meta_data: '',
        face: '',
        consume_token: '',
        user_id: ''
      }
    },
    async deleteUser (user_id) {
      try {
        const res = await apiDeleteFaceUser(user_id, this.listQuery.canteen['canteen-api-key'])
        this.$message.success('删除成功')
        this.getAllUsers()
        console.log(res)
      } catch (e) {
        console.log(e)
        this.$message.error('删除错误' + e.message)
      }
    },
    async editUser (user) {
      this.userForm = this.$_.cloneDeep(user)
      try {
        const res = await util.urlToBase64(this.userForm.url)
        this.userForm.face = res
        this.faceUserFormShow = true
        this.editFlag = true
      } catch (e) {
        this.userForm.face = ''
        this.faceUserFormShow = true
        this.editFlag = true
      }
    },
    beforeAvatarUpload (file) {
      console.log(file)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'

      if (isJPG) {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          console.log()
          this.userForm.face = e.target.result
        }
      } else {
        return this.$message.error('上传头像图片只能是 JPG 格式!')
      }/**/
    },
    handleAvatarSuccess () {

    },
    handleFilter () {

    },
    toggleFaceShow () {
      this.faceUserFormShow = true
    },
    async addUser () {
      if (this.editFlag) {
        try {
          this.$refs['form'].validate(async (valid) => {
            if (valid) {
              try {
                const res = await apiEditFaceUser(
                  this.userForm,
                  this.listQuery.canteen['canteen-api-key'])
                this.cancelAdd()
                this.getAllUsers()
                console.log(res)
              } catch (e) {
                console.log(e)
                this.$message.error('添加错误' + e.message)
              }
            } else {
              return false
            }
          })
        } catch (e) {
          console.log(e)
          this.$message.error('删除错误' + e.message)
        }
      } else {
        this.userForm.user_id = uuidv1().replace('-', '')
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            try {
              const res = await apiaddFaceUsers(this.userForm, this.listQuery.canteen['canteen-api-key'])
              this.getAllUsers()
              this.cancelAdd()
              console.log(res)
            } catch (e) {
              console.log(e)
              this.$message.error('添加错误' + e.message)
            }
          } else {
            return false
          }
        })
      }
    },
    async getAllUsers () {
      try {
        const res = await apiGetFaceUsers(this.listQuery.canteen['canteen-api-key'])
        this.users = res
        this.users.forEach(a => {
          let url = getImage('zhiyan-face-images', a.face)
          this.$set(a, 'url', url)
        })
      } catch (e) {
        console.log(e)
        this.$message.error('查询人脸用户失败' + e.message)
      }
    }
  },
  computed: {
    canteenList () {
      return this.$store.getters.canteenList()
    }
  },
  watch: {
    faceUserFormShow (val) {
      if (val === false) {
        this.editFlag = false
        // console.log(?)
        this.$refs.form.resetFields()
        this.$refs.form.clearValidate()
        this.userForm = {
          meta_data: '',
          face: '',
          consume_token: '',
          user_id: ''
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .container {
    .btn-wrapper {
      margin-top: 10px;
    }
    .avatar-uploader {
      overflow: hidden;
      .image-wrapper {
        display: inline-block;
        width: 200px;
        .image-item {
          border: 1px dashed #d9d9d9;
          cursor: pointer;
          border-radius: 6px;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      &:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        border-radius: 6px;
        border: 1px dashed #d9d9d9;

      }
    }
    .face-image {
      width: 50px;
      display: inline-block;
      .face-image-big {
        width: 100px;
        display: inline-block;
      }
    }
  }

</style>
